import React, { useEffect, useState } from 'react';
export const Button = ({
  children,
  variant = 'primary',
  className = '',
  href = '#pricing',
  ...props
}: {
  children: React.ReactNode;
  variant?: 'primary' | 'brand';
  className?: string;
  href?: string;
}) => {
  const base = 'inline-flex items-center justify-center w-full md:w-auto text-center font-montserrat font-bold uppercase tracking-wider py-4 px-8 rounded transition-transform hover:scale-105 active:scale-95';
  const variants = {
    primary: 'bg-dark text-base',
    brand: 'bg-brand text-dark'
  };
  const handleClick = () => {
    const fbq = (window as any).fbq;
    if (typeof fbq === 'function') {
      fbq('track', 'InitiateCheckout');
    }
  };
  return <a href={href} onClick={handleClick} className={`${base} ${variants[variant]} ${className}`} {...props} data-id="element-461">
      {children}
    </a>;
};
export const Countdown = ({
  className = ''
}: {
  className?: string;
}) => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 11,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        }; // Reset for demo purposes
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (n: number) => n.toString().padStart(2, '0');
  return <div className={`font-montserrat font-bold text-4xl md:text-5xl tracking-widest ${className}`} data-id="element-462">
      {format(timeLeft.hours)}{' '}
      <span className="text-brand text-2xl md:text-3xl" data-id="element-463">hs</span> :{' '}
      {format(timeLeft.minutes)}{' '}
      <span className="text-brand text-2xl md:text-3xl" data-id="element-464">min</span> :{' '}
      {format(timeLeft.seconds)}{' '}
      <span className="text-brand text-2xl md:text-3xl" data-id="element-465">seg</span>
    </div>;
};
export const Section = ({
  children,
  bg = 'base',
  className = '',
  id = ''
}: {
  children: React.ReactNode;
  bg?: 'base' | 'dark' | 'mid';
  className?: string;
  id?: string;
}) => {
  const backgrounds = {
    base: 'bg-base text-dark',
    dark: 'bg-dark text-base',
    mid: 'bg-mid text-dark'
  };
  return <section id={id} className={`py-16 md:py-24 px-6 md:px-12 lg:px-24 ${backgrounds[bg]} ${className}`} data-id="element-466">
      <div className="max-w-6xl mx-auto" data-id="element-467">{children}</div>
    </section>;
};
export const Card = ({
  children,
  className = '',
  highlighted = false
}: {
  children: React.ReactNode;
  className?: string;
  highlighted?: boolean;
}) => <div className={`bg-base text-dark rounded-xl p-6 md:p-8 shadow-sm ${highlighted ? 'border-2 border-brand shadow-md' : 'border border-gray-200'} ${className}`} data-id="element-468">
    {children}
  </div>;